import { render, staticRenderFns } from "./serSerial.vue?vue&type=template&id=33b2c566&scoped=true"
import script from "./serSerial.vue?vue&type=script&lang=js"
export * from "./serSerial.vue?vue&type=script&lang=js"
import style0 from "./serSerial.vue?vue&type=style&index=0&id=33b2c566&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b2c566",
  null
  
)

export default component.exports